import { render, staticRenderFns } from "./ServiciosPuertosPage.vue?vue&type=template&id=23b2dc1a&scoped=true"
import script from "./ServiciosPuertosPage.vue?vue&type=script&lang=js"
export * from "./ServiciosPuertosPage.vue?vue&type=script&lang=js"
import style0 from "./ServiciosPuertosPage.vue?vue&type=style&index=0&id=23b2dc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2dc1a",
  null
  
)

export default component.exports